import { SidePanelContent } from '@src/shared/ui/SidePanel';
import { useTranslation } from 'react-i18next';
import TasksList from './TasksList';

export type TasksProps = {
  /**
   * Section whose tasks to show, e.g. "absence" -- the same name the reference
   * resolvers are registered under. Omitted, the panel shows every open task
   * the viewer can reach, which is what the landing and dashboard pages want.
   */
  referenceType?: string;
};

export default function Tasks({ referenceType }: TasksProps) {
  const { t } = useTranslation();

  return (
    <SidePanelContent title={t('common.tasks', 'Tasks')}>
      <TasksList referenceType={referenceType} />
    </SidePanelContent>
  );
}
